// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tauU","col":"styles_col__2WFzX"};